export default __webpack_public_path__ + "static/media/hero-color-230.ea85b599.mp4";